import React from 'react';
import { CheckBig } from './CheckBig';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import { Trans } from '@lingui/macro';

export const Benefits = () => {
  const benefits = [
    <Trans key={0}>
      <b>Série videí s 35 českými a slovenskými podnikateli a odborníky.</b>{' '}
      Předají své zkušenosti, znalosti a také chyby, kterých se sami dopustili.
    </Trans>,

    <Trans key={1}>
      <b>Komplexní přehled o tom, co tě v podnikání čeká.</b> Od práva, přes
      finance a obchod až po vlastní motivaci. Říkej tomu třeba rychlokurz MBA.
    </Trans>,

    <Trans key={2}>
      Metodiky, nástroje, legislativní povinnosti související s podnikáním.{' '}
      <b>Vše ti ukáží přední experti.</b>
    </Trans>,

    <Trans key={3}>
      <b>Připravíme tě na vše, co tě čeká a nemine.</b> Ať se nemusíš obávat, že
      tě něco překvapí, nebo že něco podceníš. Pak už je jen na tobě, jak s tím
      naložíš.
    </Trans>,

    <Trans key={4}>
      <b>Za tento kurz nezaplatíš ani korunu!</b>
    </Trans>,
  ];

  return (
    <div>
      <Typography variant={'h3'} gutterBottom>
        <Trans>Co tě v Digital Class čeká?</Trans>
      </Typography>
      <Content>
        {benefits.map((line, index) => (
          <BenefitRow key={index}>
            <CheckBig />
            <Typography fontSize={15}>{line}</Typography>
          </BenefitRow>
        ))}
      </Content>
    </div>
  );
};

const BenefitRow = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;

  grid-gap: 16px;
  margin-bottom: 24px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
